import { gsap } from "gsap";

export default class Navigation {
  constructor(app) {
    this.app = app
    this.links = document.querySelectorAll(".nav__item");
    
    this.init()
  }

  init() {
    this.setInitialState();
    this.initAnchorLinks()
  }

  setInitialState() {
    // console.log('set nav anim');
    
    gsap.set([...this.links], {
      autoAlpha: 0,
      scale: 0,
      pointerEvents: "none",
    });
  }


  createTimeline() {
    const tl = gsap.timeline();

    tl.to(this.links, {
      autoAlpha: 1,
      scale: 1.0,
      duration: 0.8,
      ease: "back.out(2)",
      stagger: 0.2,
      pointerEvents: "all",
    });

    return tl;
  }

  initAnchorLinks() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const targetElement = document.querySelector(
          anchor.getAttribute("href")
        );
        if (targetElement) {
          this.app.scroll.lenis.scrollTo(targetElement, {
            offset: 0,
            duration: 1.5,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          });
        }
      });
    });
  }

  toggleVisibility() {}
}
